export default __webpack_public_path__ + "static/fuzzing-74be698d099fb4664e998afa5b1b1363.png";